import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, PropType, ref } from "vue";
import NavigationBar from "../shared/NavigationBar.vue";
import SearchInput from "../shared/inputs/SearchInput.vue";
import NaverMap from "./NaverMap.vue";
import { IAddressSearchInfo } from "@/domain/entities/address";
import AddressSearch from "../address/AddressSearch.vue";
import MapZoomLevelSetter from "@/components/map/MapZoomLevelSetter.vue";


const __default__ = {
  name: "AddressSearchMap",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  initialAddress: {
    type: Object as PropType<IAddressSearchInfo>,
  },
},
  emits: ["onClickClose", "onClickApplyBtn"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const addressSearch = ref<InstanceType<typeof AddressSearch>>();
const searchInput = ref<typeof SearchInput>();

// 주소 검색하기
const searchKeyword = ref("");
const updateSearchKeyword = (keyword: string) => {
  searchKeyword.value = keyword;
};

// 검색 결과 상태 관리
const hasSearchResults = ref(false);

// 검색 결과 상태 업데이트 함수
const updateSearchResultsStatus = (hasResults: boolean) => {
  hasSearchResults.value = hasResults;
};

// 기본 위치 : SK 하이닉스 이천캠퍼스
const defaultAddress = {
  latitude: 37.2529797,
  longitude: 127.4806853,
} as IAddressSearchInfo;

// 선택한 주소 처리
const selectedAddress = ref<IAddressSearchInfo>(
  props.initialAddress ?? defaultAddress
);

const isSelectedAddress = computed(
  () => selectedAddress.value?.roadAddress || selectedAddress.value?.dongAddress
);

const selectAddress = (address: IAddressSearchInfo) => {
  selectedAddress.value = address;
};

const updateSearchKeywordByAddress = (address: IAddressSearchInfo) => {
  const { roadAddress, dongAddress } = address;
  const addressText = roadAddress?.length ? roadAddress : dongAddress;
  updateSearchKeyword(addressText ?? "");
};

const updateAddressByMap = (address: IAddressSearchInfo) => {
  selectAddress(address);
  updateSearchKeywordByAddress(address);
};

const infoWindowContent = computed(() => {
  if (
    !selectedAddress.value?.roadAddress &&
    !selectedAddress.value?.dongAddress
  )
    return "";

  const { roadAddress, dongAddress } = selectedAddress.value;
  const address = roadAddress?.length ? roadAddress : dongAddress;

  return `<div class="info-wrapper">
      <p>${address}</p>
    </div>`;
});

const emitOnClickClose = () => {
  emit("onClickClose");
};

const emitOnClickApplyBtn = () => {
  if (!selectedAddress.value) return;

  emit("onClickApplyBtn", selectedAddress.value);
};

const hideSearchResult = () => {
  if (!addressSearch.value) return;

  addressSearch.value.toggleShowSearchResult(false);
};

const initSearchKeyword = () => {
  if (!props.initialAddress) return;

  updateSearchKeywordByAddress(props.initialAddress);
};

const MIN_ZOOM_LEVEL = 8;
const MAX_ZOOM_LEVEL = 16;
const zoomLevel = ref(14);
const increaseZoomLevel = () => {
  if (zoomLevel.value < MAX_ZOOM_LEVEL) zoomLevel.value++;
};
const decreaseZoomLevel = () => {
  if (zoomLevel.value > MIN_ZOOM_LEVEL) zoomLevel.value--;
};

onMounted(() => {
  initSearchKeyword();
  setTimeout(() => {
    searchInput.value?.focusInputField();
  }, 300);
});

const __returned__ = { props, emit, addressSearch, searchInput, searchKeyword, updateSearchKeyword, hasSearchResults, updateSearchResultsStatus, defaultAddress, selectedAddress, isSelectedAddress, selectAddress, updateSearchKeywordByAddress, updateAddressByMap, infoWindowContent, emitOnClickClose, emitOnClickApplyBtn, hideSearchResult, initSearchKeyword, MIN_ZOOM_LEVEL, MAX_ZOOM_LEVEL, zoomLevel, increaseZoomLevel, decreaseZoomLevel, NavigationBar, NaverMap, AddressSearch, MapZoomLevelSetter }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})